import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import BackToStreamButton from '../../Duperbrowse/BackToStreamButton';
import Details from '../../DeviationViews/Details';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import CentralColumn from '../_partials/CentralColumn';
import DesktopLayout from '../_partials/DesktopLayout';

interface Props {
  deviation: PapiDeviation;
}

const DesktopStatusPage: React.FC<React.PropsWithChildren<Props>> = ({ deviation }) => {
  return (
    <DesktopLayout
      deviation={deviation}
      stageContent={
        <>
          <ArtStage deviation={deviation} />
          <BackToStreamButton />
          <ActionBar deviation={deviation} />
        </>
      }
      metaContent={
        <CentralColumn>
          <Details deviation={deviation} />
          <UserGiftSaleBanner user={deviation.author} />
        </CentralColumn>
      }
    />
  );
};
DesktopStatusPage.displayName = 'DesktopStatusPage';

export default DesktopStatusPage;
